<template>
    <tr>
        <td>
            {{invoicenumber}}
        </td>
        <td>
            {{createdFormated}}
        </td>
        <td>
            {{totalFormated}}
        </td>
        <td>
            <button class="btn btn-primary" v-on:click="download">Download</button>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'

export default {
  name: 'InvoiceItem',

  props: [
    'id',
    'invoicenumber',
    'total',
    'created_at'
  ],

  computed: {
    totalFormated () {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.total / 100)
    },
    createdFormated () {
      return moment(this.created_at).format('DD.MM.YYYY')
    },
    downloadLink () {
      return '/api/invoice/' + this.id + '/download'
    }

  },

  methods: {
    download () {
      this.axios({
        url: this.downloadLink,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.invoicenumber + '.pdf')
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
    }
  }
}
</script>
